// removed by extract-text-webpack-plugin
module.exports = {"publishBtn":"_1AJNXPyE7ezbd2LK4xDioR","foreignPublishBtn":"N4y8JhkT3gctpG6zQEcJd","button":"_3S7hnLZru2XrhCtw5cqyg7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPublishButton/OMPublishButton.scss
// module id = 1674
// module chunks = 0